import React, { useEffect, useRef, useState } from 'react';
import PageContainer from '../../../components/PageContainer';
import MainContent from '../../../components/MainContent';
import PageTitle from '../../../components/Common/PageTitle/PageTitle';
import Pagination from '../../../components/Common/Pagination';
import ActivityLoader from '../../../components/Common/ActivityLoader';
import Notification from '../../../components/Common/Notification';
import ActionDropdownItem from '../../../components/Common/PageTitle/ActionDropdownItem';
import functions from '../../../util/functions';
import { useGymInvoice } from '../../../DataStore/Gym/GymInvoiceContext';
import printContent from '../../../util/araknerdlib';
import DateRangeSelector from '../../../components/Report/DateRangeSelector';
import AlertDateSelector from '../../../components/Report/AlertDateSelector';

const GymInvoiceHistoryPage = () => {
    const [selection, setSelelection] = useState(false);
    const statementRef = useRef(); // Ref to enclose statement content for printing
    const [showBasicDateRange, setShowBasicDateRange] = useState(false);
    const [showAdvancedDateRange, setShowAdvancedDateRange] = useState(false);


    const {
        metaData, 
        getGymInvoices, 
        GymInvoiceListing, 
        setCurrentPage,
        dispatch, 
    } = useGymInvoice();

    useEffect(() => {
        getGymInvoices();
    }, []);

    const handleConfirmDateRange = async (range) => {
        dispatch({ type: 'dateRange', payload: range });
        await getGymInvoices(true, false, range);
    };

    const handleConfirmSpecificDates = async (dates) => {
        await getGymInvoices(true, false, null, dates);
    };

    const PageActions = () => (<>
        <ActionDropdownItem iconClass="fas fa-calendar-alt text-success" label="Filter Date Range" onClick={()=>setShowBasicDateRange(true)}/>
        <ActionDropdownItem iconClass="fas fa-calendar-alt text-info" label="Filter Specific Dates..." onClick={()=>setShowAdvancedDateRange(true)}/>
        <ActionDropdownItem iconClass="fa fa-print text-secondary" label="Print" onClick={()=>printContent(statementRef, "Sale Invoices")}/>
        <ActionDropdownItem iconClass="fa fa-refresh text-info" label="Refresh" onClick={() => getGymInvoices(true)} />
    </>);

    return (
        <>
        <PageContainer>
            <MainContent>
                <PageTitle
                    title="Sale Invoices"
                    description="Track all gym invoices, balances and payment history."
                    iconClass="fas fa-file-invoice"
                    sticky={true}
                    PageActions={PageActions}
                    Pagination={metaData ? <Pagination
                        metaData={metaData}
                        onPageChange={(page) => setCurrentPage(page)}
                    /> : <></>}
                />

                <div className="card mb-3">
                    <div className="card-body">
                    <div ref={statementRef}>
                        <table className="table table-hover">
                            <thead className="table-light">
                                <tr>
                                    <th>#</th>
                                    <th>Invoice No</th>
                                    <th>Customer Name</th>
                                    <th>Phone Number</th>
                                    <th>Invoice Date</th>
                                    <th>Invoice Total</th>
                                    <th>Total Paid</th>
                                    <th>Balance</th>
                                    <th>Created By</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Array.isArray(GymInvoiceListing) && GymInvoiceListing.map((item, key) => (
                                    <tr key={key} onClick={() => setSelelection(item)} className={`link ${selection?.invoice_id === item.invoice_id ? 'selected-row' : ''}`}>
                                        <td>{key + 1}</td>
                                        <td className="text-primary font-weight-bold">{item.invoice_number}</td>
                                        <td>{item.customer?.full_name}</td>
                                        <td>{item.customer?.phone_number}</td>
                                        <td>{item.invoice_date ? functions.formatDate(item.invoice_date) : 'N/A'}</td>
                                        <td>UGX {functions.numberFormat(item.total_billed)}</td>
                                        <td>UGX {functions.numberFormat(item.total_paid)}</td>
                                        <td className={item.balance * 1 > 0 ? 'text-danger font-weight-bold' : 'text-success'}>
                                          UGX {functions.numberFormat(item.balance)}
                                        </td>
                                        <td>{item.created_by?.full_name}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        </div>
                        {!GymInvoiceListing && <ActivityLoader />}
                        {GymInvoiceListing === "404" && <Notification message="No invoice records found." closable={false} />}
                    </div>
                </div>
            </MainContent>
        </PageContainer>
        <DateRangeSelector
            show={showAdvancedDateRange}
            onClose={() => setShowAdvancedDateRange(false)}
            onConfirm={handleConfirmSpecificDates}
        />
        <AlertDateSelector
            show={showBasicDateRange}
            onClose={()=>setShowBasicDateRange(false)}
            onConfirm={handleConfirmDateRange}
            />
        </>
    );
};

export default GymInvoiceHistoryPage;
